import React from 'react';
import styled from 'styled-components';
import { Check } from 'lucide-react';
import colors from 'theme/colors';

/**
 * Trilha do cadastro.
 *
 * A barra anterior era `valor * (lastStep * 10.5)`: o passo 1 nascia com 31,5%
 * preenchido e o último parava em 94,5%, sem nunca fechar. Além do número certo,
 * aqui os passos são nomeados — saber que o documento vem por último muda a
 * decisão de começar agora ou depois.
 */
export default function PartnerStepper({ steps, currentStep }) {
    const percent = (currentStep / steps.length) * 100;

    return (
        <Wrapper>
            <Track
                role='progressbar'
                aria-valuenow={currentStep}
                aria-valuemin={1}
                aria-valuemax={steps.length}
                aria-label={`Passo ${currentStep} de ${steps.length}: ${steps[currentStep - 1]?.label}`}
            >
                <Fill $percent={percent} />
            </Track>

            <List>
                {steps.map((step, index) => {
                    const position = index + 1;
                    const isDone = position < currentStep;
                    const isCurrent = position === currentStep;

                    return (
                        <Item
                            key={step.id}
                            $state={isDone ? 'done' : isCurrent ? 'current' : 'todo'}
                            aria-current={isCurrent ? 'step' : undefined}
                        >
                            <Bullet $state={isDone ? 'done' : isCurrent ? 'current' : 'todo'}>
                                {isDone ? <Check size={11} strokeWidth={3} aria-hidden='true' /> : position}
                            </Bullet>
                            <Label $state={isDone ? 'done' : isCurrent ? 'current' : 'todo'}>{step.label}</Label>
                        </Item>
                    );
                })}
            </List>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
`;

const Track = styled.div`
    width: 100%;
    height: 6px;
    border-radius: 999px;
    background: #EEECF7;
    overflow: hidden;
`;

const Fill = styled.div`
    height: 100%;
    width: ${({ $percent }) => $percent}%;
    border-radius: 999px;
    background: #6111F0;
    transition: width 0.35s cubic-bezier(0.22, 1, 0.36, 1);
`;

const List = styled.ol`
    display: flex;
    justify-content: space-between;
    gap: 8px;
    list-style: none;
    margin: 15px 0 0;
    padding: 0 5px 0 1px;
`;

const Item = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: ${({ $state }) => ($state === 'todo' ? '#A3A1B5' : '#1B1840')};
`;

const Bullet = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 10.5px;
    font-weight: 600;
    background: ${({ $state }) => ($state === 'todo' ? '#ECEAF5' : '#6111F0')};
    color: ${({ $state }) => ($state === 'todo' ? '#8C8AA0' : '#fff')};
`;

const Label = styled.span`
    font-size: 11.6px;
    font-weight: ${({ $state }) => ($state === 'current' ? 600 : 500)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
